import client from '@libs/HttpClient';
class RecruitmentCompaniesService {
  static listRecruitmentCompanies(request) {
    const page_no = request.queryKey[1];
    const searchText = request.queryKey[2];
    const status = request.queryKey[3];
    const companySize = request.queryKey[4];
    const headOfficeCity = request.queryKey[5];

    return client.get(
      `/recruitment-candidate-companies/?search=${searchText}&page=${page_no}&status=${status}&company_size=${companySize}&recruitment_city_id=${headOfficeCity}`,
      request
    );
  }
  static addRecruitmentCompanies(request) {
    return client.post('/recruitment-candidate-companies', request);
  }
  static showRecruitmentCompanies(params) {
    return client.get(`/recruitment-candidate-companies/${params}`);
  }
  static viewRecruitmentCompanies(params) {
    return client.get(`/recruitment-candidate-companies/${params}/edit`);
  }
  static updateRecruitmentCompanies(request) {
    return client.put(`/recruitment-candidate-companies/${request.id}`, request);
  }
  static deleteRecruitmentCompanies(request) {
    return client.delete(`/recruitment-candidate-companies/${request.id}`, request);
  }
  static changeStatusRecruitmentCompanies(request) {
    return client.patch(`/recruitment-candidate-companies/change-status/${request.id}`, request);
  }
  static listRecruitmentCompaniesCity(request) {
    return client.get('/recruitment-candidate-companies-cities');
  }
}
export { RecruitmentCompaniesService };
